// @flow
import * as React from 'react';
import styled, { withTheme } from 'styled-components';
import { translate } from 'react-i18next';
import { Numeric } from 'common/components/Number';
import { type MetricType } from '../../../domain/DashboardData';

const StyledMetric = styled(Numeric)`
  font-size: ${props => props.fontSize};
  font-weight: bold;
  text-align: center;
  margin: 4px;
`;

const ListeningTime = styled(StyledMetric)`
  color: ${({ theme }) => theme.V3.colors.listeningTime};
`;

const Reach = styled(StyledMetric)`
  color: ${({ theme }) => theme.V3.colors.reach};
`;

interface MetricProps {
  value: number;
  theme: Object;
  type: MetricType;
}

interface CurrentMetricProps extends MetricProps {
  t: any;
}

function CurrentMetricComponent({ value, type, t, theme }: CurrentMetricProps) {
  const fontSize = '22px';
  switch (type) {
    case 'reach':
      return <Reach value={value} suffix={t('personsSymbol')} fontSize={fontSize} />;
    case 'listeningTime':
      return <ListeningTime value={value} suffix={t('personsSymbol')} fontSize={fontSize} />;
    default:
      throw Error(type + ' not found');
  }
}

export const CurrentMetric = translate()(withTheme(CurrentMetricComponent));


function MetricVariationComponent({ value, type, theme }: MetricProps) {
  const fontSize = '16px';
  switch (type) {
    case 'reach':
      return <Reach value={value} showPlusSign fontSize={fontSize} />;
    case 'listeningTime':
      return <ListeningTime value={value} showPlusSign fontSize={fontSize} />;
    default:
      throw Error(type + ' not found');
  }
}

export const MetricVariation = withTheme(MetricVariationComponent);



// WEBPACK FOOTER //
// ./src/statsradio/modules/dashboard/v2/components/audienceComparison/Metric.js